import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { chargePointActions } from "../store/actions/chargePoint.actions";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import validationHelper from "../utils/helpers/validation.helper";
import { chargePointStatusEnum } from "../enums/chargePoint/chargePointStatusEnum";
import { connectorStatusEnum } from "../enums/chargePoint/connectorStatusEnum";
import { inputElementModel } from "../models/common/inputElement.model";
import InputElementComponent from "../components/common/InputElementComponent";
import { buttonElementModel } from "../models/common/buttonElement.model";
import ButtonElementComponent from "../components/common/ButtonElementComponent";
import sessionStorageService from "../services/storage/sessionStorage.service";
import alertService from "../services/alert/alert.service";

export const NotFoundPageComponent = ({ chargePointActions }) => {
  const navigate = useNavigate();
  const [serialNumber, setSerialNumber] = useState("");
  const [connectorNumber, setConnectorNumber] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    chargePointActions.resetSelectedChargePoint();
  }, []);

  const handleSerialNumberChanged = (event) => {
    const { name, value } = event.target;
    setSerialNumber(value);
  };

  const handleConnectorNumberChanged = (event) => {
    const { name, value } = event.target;
    setConnectorNumber(value);
  };

  const validate = () => {
    const newErrors = {};
    if (!serialNumber) newErrors.serialNumber = "מספר סריאלי הוא שדה חובה";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSearchChargePointClicked = async () => {
    if (validate()) {
      const response = await chargePointActions.getChargePointBySerialNumber(serialNumber, connectorNumber);
      if (!response || !validationHelper.validateHttpResponse(response)) {
        setErrors({ searchError: "מטען לא נמצא" });
        return;
      }

      const chargePointDetails = response.payload;
      handleChargePointDetails(chargePointDetails);
    }
  };

  const handleChargePointDetails = (chargePointDetails) => {
    // 1. check if the charge point connected
    if (chargePointDetails.chargePointStatus !== chargePointStatusEnum.Connected) {
      alertService.error("עמדת טעינה לא זמינה", `עמדת טעינה ${chargePointDetails.serialNumber} לא זמינה כעת. אנא נסה שנית מאוחר יותר`);
      return;
    }

    // 2. check if the connector busy
    if (
      chargePointDetails.connectorStatus === connectorStatusEnum.Charging ||
      chargePointDetails.connectorStatus === connectorStatusEnum.SuspendedEV ||
      chargePointDetails.connectorStatus === connectorStatusEnum.SuspendedEVSE
    ) {
      navigate(`transactionLogin/chargePoint/${chargePointDetails.id}`);
      return;
    }

    // 2. navigate to charge point with the selected connector
    navigate(`company/${chargePointDetails.companyId}/chargePoint/${chargePointDetails.id}`);
  };

  const getSerialNumberInputElement = () => {
    const inputElementProps = {
      ...inputElementModel,
      name: "serialNumber",
      value: serialNumber,
      onChange: handleSerialNumberChanged,
      label: "מספר סריאלי",
      placeholder: "מספר סריאלי",
      required: true,
      error: errors.serialNumber,
    };

    return <InputElementComponent inputElementProps={inputElementProps} />;
  };

  const getConnectorNumberInputElement = () => {
    const inputElementProps = {
      ...inputElementModel,
      type: "number",
      name: "connectorNumber",
      value: connectorNumber,
      onChange: handleConnectorNumberChanged,
      placeholder: "מספר מחבר",
      label: "יותר ממחבר אחד? הזן מספר מחבר",
      required: false,
    };

    return <InputElementComponent inputElementProps={inputElementProps} />;
  };

  const getSubmitButtonElement = () => {
    const buttonElementProps = {
      ...buttonElementModel,
      label: "חפש",
      onClick: handleSearchChargePointClicked,
    };

    return <ButtonElementComponent buttonElementProps={buttonElementProps} />;
  };

  return (
    <div className="flexColumn gap10">
      {getSerialNumberInputElement()}
      {getConnectorNumberInputElement()}
      {errors?.searchError}
      {getSubmitButtonElement()}
    </div>
  );
};

const mapStateToProps = (state) => ({
  chargePointReducer: state.chargePointReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    chargePointActions: bindActionCreators(chargePointActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotFoundPageComponent);
